'use strict'

const localizedContent = (entry, locale) => {
	const localeFilter = content => content.locale == locale
	return (entry.content.some(localeFilter) ? entry.content.filter(localeFilter) : entry.content)[0]
}

export {
	localizedContent
}